// 下载文件
import axios from 'axios'
import Vue from 'vue'

function downloadFile(file) {
	axios.post("/api/download/contract", {
		url: file.url,
	}, {
		'responseType': "blob",
		headers: {
			'Content-Type': 'application/json',
			'data-type': 'Buffer'
		},
	}).then(res => {
		const link = document.createElement("a");
		let blob = new Blob([res.data], {
			// type: "application/vnd.ms-excel"
		});
		// 给a标签添加属性
		link.style.display = "none";
		link.href = URL.createObjectURL(blob);
		link.download = `${file.name}`;
		document.body.appendChild(link);
		link.click(); //执行下载
		URL.revokeObjectURL(link.href) //释放url
		document.body.removeChild(link); //释放标签
	})
}

export default downloadFile;